import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import * as classes from './NodeServiceCard.module.scss';

export const NodeServiceCard = ({ card }) => (
  <Container fluid className={`position-relative shadow-service-card transition-2x overflow-hidden rounded-xl px-0 ${classes.container}`}>
    <Row noGutters>
      <Col xs={12} className="justify-content-center d-flex p-3 text-center">
        <GatsbyImage alt={card.image?.alt ?? ''} image={card.image?.image?.asset?.gatsbyImageData ?? imgFallback} objectFit="contain" />
      </Col>
      <Col xs={12} style={{ minHeight: '85px' }} className="d-flex justify-content-center align-items-center px-3 py-3 text-center">
        <Link to={card.url} className="stretched-link text-size-md font-weight-black text-black">
          {card.title}
        </Link>
      </Col>
    </Row>
  </Container>
);

NodeServiceCard.propTypes = {
  card: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.shape({}).isRequired,
    displaySize: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};
